import { render, staticRenderFns } from "./Donut.vue?vue&type=template&id=a35a3c40&"
import script from "./Donut.vue?vue&type=script&lang=js&"
export * from "./Donut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports